






















import Vue from 'vue'
import Experience from '@/components/Experience.vue'
interface ExperiencesData {
  title?: string,
  experiences: keyExperience[]
}
interface keyExperience {
  number: string,
  description: string
}
export default Vue.extend({
  name: 'Experiences',
  components: {
    Experience
  },
  props: {
    ExperiencesData: {
      type: Object as() => ExperiencesData,
      require: true
    }
  }
})
